import { useTranslation } from "react-i18next";
import { createFileRoute, Link } from "@tanstack/react-router";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const Route = createFileRoute("/error-auth")({
  component: VerifyMagicLinkError,
});

export default function VerifyMagicLinkError() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full">
            <AlertCircle className="h-6 w-6 text-red-500" />
          </div>
          <CardTitle className="text-xl font-semibold">{t("Authentication Failed")}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center font-medium">
            {t("Sorry, this token was either expired or already used. Please try logging in again.")}
          </div>

          <div className="space-y-3">
            <Button asChild className="w-full">
              <Link to="/login">
                <ArrowLeft className="mr-2 h-4 w-4" />
                {t("Back to Login")}
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
